import { ConsultaData, RutaProductos, codeNombreProductoURL } from '../componentes/funcionesEspeciales'
import { useEffect, useState } from 'react';

import Card from '../styles/cardPollo.module.css';

function MenuPollos({ agregarItemCarro }) {
    const [familias, setFamilias] = useState([])
    const getFamilias = () => {
        ConsultaData(`?/web/getWeb`, {}, 'POST')
            .then(response => {
                //setEnviando(false)
                if (response) {
                    let datos = []
                    response.forEach(item => {
                        if (!datos[item.fam_nombre]) {
                            datos[item.fam_nombre] = {
                                fam_nombre: item.fam_nombre,
                                descripcion: item.descripcion,
                                productos: []
                            };
                        }
                        datos[item.fam_nombre].productos.push({
                            id: item.id,
                            art_nombre: item.art_nombre,
                            art_descripcion: item.art_descripcion,
                            art_precio_ventaconigv: item.art_precio_ventaconigv,
                            art_imagen: item.art_imagen
                        });
                    })
                    datos = Object.values(datos)
                    //console.log("ww", datos)
                    setFamilias(datos)
                } else {
                    console.log("ERROR", response)
                }

            })
    }
    useEffect(() => {
        getFamilias()
    }, [])
    const agregarItemCarrito = (producto) => {
        let producto_guardar = {
            id: producto.id,
            nombre: producto.art_nombre,
            imagen: producto.art_imagen,
            //precio_venta: calcularPrecioFinal(producto.valor_venta_base, producto.tipo_igv, producto.moneda),
            precio_venta: producto.art_precio_ventaconigv,
            //talla: producto.talla,
            //color: producto.color,
            //descuento: 0,
            cantidad: 1,
        }
        agregarItemCarro(producto_guardar)
    }
    const abrirProducto = (nombre) => {
        let nombre_del_producto = codeNombreProductoURL(nombre)
        window.open('./producto/' + nombre_del_producto, '_blank')
    }
    return (
        <div className="">
            <h6 className='p-4 national-bold'>Sírvase a realizar su Pedido</h6>
            <div className="accordion accordion-flush border" id="accordionFlushExample">
                {/* {JSON.stringify(familias)} */}
                {familias.map((item, key) => (
                    <div className="accordion-item" keu={key}>
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed d-flex" type="button" data-bs-toggle="collapse"
                                data-bs-target={"#flush-collapse" + key} aria-expanded="false" aria-controls={"flush-collapse" + key}>
                                <div className='d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center'>
                                    <h3>{item.fam_nombre}</h3>
                                    <small className='ml-0 ml-md-5 mt-3 mt-md-0 text-uppercase d-block'>{item.descripcion}</small>
                                </div>
                            </button>
                        </h2>
                        <div id={"flush-collapse" + key} className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                            <div className="accordion-body border-top px-0">
                                <div className="card-body">
                                    <div className="row heightRowScrollMenu">
                                        {item.productos.map((producto, index) => (
                                            <div className={`${Card.cardPollo} col-lg-3 col-md-4 col-sm-6 meal-type ng-isolate-scope`} key={index}>
                                                <a href="#" className="item-details" > Detalles</a>
                                                <div className="single-box" >
                                                    <div className="product-item-img img6" onClick={() => abrirProducto(producto.art_nombre)}>
                                                        <div className="container-img" >
                                                            <img ng-if="imgPurpose=='big'" title="KFC MEGA MIX - 8 PIEZAS"
                                                                //src={Pollo}
                                                                src={RutaProductos + producto.art_imagen} />
                                                        </div>
                                                    </div>
                                                    <div className="text-div">
                                                        <div className="meal-name">
                                                            <div className="row">
                                                                <h6 className="uiname-item col pr-0 ng-binding">
                                                                    {producto.art_nombre}
                                                                </h6>
                                                                <p className="price-item-small col-auto ng-binding ng-scope">
                                                                    S/ {producto.art_precio_ventaconigv}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {/* <div className="item-list" >
                                                            <span className="ng-binding">
                                                                {producto.art_descripcion}
                                                            </span>
                                                        </div> */}
                                                        <div className="">
                                                            <button className="btn block"
                                                                onClick={(e) => { agregarItemCarrito(producto) }}>
                                                                Agregar Al Carro
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}


            </div>
        </div>
    )
}
export default MenuPollos;